import resize from "./resize";

const initMoreButton = () => {
  const buttons = document.querySelectorAll("[data-reviews-show-button]");
  if (!buttons.length) return;

  const wrapper = document.body;

  const watchShowButton = () => {
    buttons.forEach((button) => {
      const card = button.parentElement;
      const cardTextMaxHeight = parseInt(window.getComputedStyle(card.querySelector(".comments__card-text")).maxHeight);
      const cardTextHeight = card.querySelector(".comments__card-text").scrollHeight;
      if (cardTextHeight <= cardTextMaxHeight) {
        button.classList.add("is-hidden");
      } else {
        button.classList.remove("is-hidden");
      }
    })
  }

       
  watchShowButton();
  resize(watchShowButton);

  wrapper.addEventListener("click", (evt) => {
    const openCard = document.querySelector('.comments__card.is-open');
    if (openCard) {
      setTimeout(() => {
        openCard.classList.remove('is-open');
        openCard.querySelector("[data-reviews-show-button]").textContent = "Развернуть кейс";
      }, 50)
      
    }

    if (evt.target.closest("[data-reviews-show-button]")) {
      const button = evt.target.closest("[data-reviews-show-button]");
      const currentCard = evt.target.closest(".comments__card");
      currentCard.classList.add("is-open");
      button.textContent = "Свернуть кейс";
    }
  });


  // Функция по сокращению текста
  String.prototype.limit = function (limit, userParams) {
    var text = this,
      options = {
        ending: "...", // что дописать после обрыва
        trim: true, // обрезать пробелы в начале/конце?
        words: true, // уважать ли целостность слов?
      },
      prop,
      lastSpace;

    //  проверить limit, без него целого положительного никак
    if (limit !== parseInt(limit) || limit <= 0) return this;

    // применить userParams
    if (typeof userParams == "object") {
      for (prop in userParams) {
        if (userParams.hasOwnProperty.call(userParams, prop)) {
          options[prop] = userParams[prop];
        }
      }
    }

    // убрать пробелы в начале /конце
    if (options.trim) text = text.trim();

    if (text.length <= limit) return text; // по длине вписываемся и так

    text = text.slice(0, limit); // тупо отрезать по лимиту
    lastSpace = text.lastIndexOf(" ");
    if (options.words && lastSpace > 0) {
      // урезать ещё до границы целого слова
      text = text.substr(0, lastSpace);
    }

    return text + options.ending;
  };

  // Добавления многоточия в карточке программы
  function resizeTextPrograms() {
    try {
      const wrapper = document.querySelector('.comments');
      const descriptions = wrapper.querySelectorAll(".comments__card-video .comments__card-text");

      descriptions.forEach((element) => {
        element.textContent = element.textContent.limit(110, {
          words: false,
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  resizeTextPrograms();
};

export default initMoreButton;
